import {
  TAddEditHealthSystemRequest,
  THealthSystem
} from '../../HealthSystems/types'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  VALIDATION_MESSAGES
} from '../../../constants'
import Fetcher from '../../../services/Fetcher'
import {
  TAddEditHealthSystemDataWithAddedDepartments,
  TAddEditHealthSystemDataWithStringDepartments
} from '../HealthSystems/FullView/types'
import { TAddEditHospitalRequest } from '../../HealthSystemDetails/types'
import {
  TActivateHospitalsRequest,
  TArchiveHospitalsRequest,
  THospitalsListRequest,
  THospitalsListResponse
} from '../../HealthSystemDetails/HospitalsTable/types'
import { TAddEditHospitalResponse } from 'components/Forms/forms.addEditHospital.d'

const fetcher = new Fetcher({})

export const addHealthSystem = async (uuid, data) =>
  fetcher.request<
    TAddEditHealthSystemRequest,
    TAddEditHealthSystemDataWithStringDepartments
  >({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}`,
    method: HTTP_METHODS.POST,
    successMessage: `Health system ${VALIDATION_MESSAGES.SM0009} added.`,
    data
  })

export const editHealthSystem = async (uuid, data, id) =>
  fetcher.request<TAddEditHealthSystemRequest, THealthSystem>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.UPDATE}`,
    method: HTTP_METHODS.PUT,
    successMessage: `Health system ${VALIDATION_MESSAGES.SM0009} saved.`,
    data
  })

export const getHealthSystemData = async (uuid, id) =>
  fetcher.request<unknown, TAddEditHealthSystemDataWithAddedDepartments>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/`,
    method: HTTP_METHODS.GET
  })

export const getHealthSystemOutsideCommunityData = async (uuid) =>
  fetcher.request<unknown, TAddEditHealthSystemDataWithAddedDepartments>({
    url: `${API_DICTIONARY.COMMUNITIES}${API_DICTIONARY.HEALTH_SYSTEMS}${uuid}/`,
    method: HTTP_METHODS.GET
  })

export const editHealthSystemOutsideCommunity = async (uuid, data) =>
  fetcher.request<TAddEditHealthSystemRequest, THealthSystem>({
    url: `${API_DICTIONARY.COMMUNITIES}${API_DICTIONARY.HEALTH_SYSTEMS}${uuid}/${API_DICTIONARY.UPDATE}`,
    method: HTTP_METHODS.PUT,
    successMessage: `Health system ${VALIDATION_MESSAGES.SM0009} saved.`,
    data
  })

const outsideCommunityHospitalsUrl = (hsId: string) =>
  `${API_DICTIONARY.COMMUNITIES}${API_DICTIONARY.HEALTH_SYSTEMS}${hsId}/${API_DICTIONARY.HOSPITALS}`

export const getHospitalsOutsideCommunity = async (
  hsId: string,
  params?: THospitalsListRequest['params']
) =>
  fetcher.request<THospitalsListRequest, THospitalsListResponse>({
    url: outsideCommunityHospitalsUrl(hsId),
    method: HTTP_METHODS.GET,
    params
  })

export const archiveHospitalsOutsideCommunity = async (
  hsId: string,
  data: TArchiveHospitalsRequest['data']
) =>
  fetcher.request<TArchiveHospitalsRequest['data'], THospitalsListResponse>({
    url: `${outsideCommunityHospitalsUrl(hsId)}archive/`,
    method: HTTP_METHODS.POST,
    data
  })

export const activateHospitalsOutsideCommunity = async (
  hsId: string,
  data: TActivateHospitalsRequest['data']
) =>
  fetcher.request<TActivateHospitalsRequest['data'], THospitalsListResponse>({
    url: `${outsideCommunityHospitalsUrl(hsId)}activate/`,
    method: HTTP_METHODS.POST,
    data
  })

export const getHospitalDataOutsideCommunity = async (
  hsId: string,
  hospitalId: string
) =>
  fetcher.request<unknown, TAddEditHospitalResponse>({
    url: `${outsideCommunityHospitalsUrl(hsId)}${hospitalId}/`,
    method: HTTP_METHODS.GET
  })

export const addHospitalOutsideCommunity = async ({
  hsId,
  data
}: {
  hsId: string
  data: TAddEditHospitalRequest['data']
}) =>
  fetcher.request<TAddEditHospitalRequest['data'], THospitalsListResponse>({
    url: outsideCommunityHospitalsUrl(hsId),
    method: HTTP_METHODS.POST,
    successMessage: `Hospital ${VALIDATION_MESSAGES.SM0009} added.`,
    data
  })

export const editHospitalOutsideCommunity = async ({
  hsId,
  hospitalId,
  data
}: {
  hsId: string
  hospitalId: string
  data: TAddEditHospitalRequest['data']
}) =>
  fetcher.request<TAddEditHospitalRequest['data'], THospitalsListResponse>({
    url: `${outsideCommunityHospitalsUrl(hsId)}${hospitalId}/`,
    method: HTTP_METHODS.PUT,
    successMessage: `Hospital ${VALIDATION_MESSAGES.SM0009} saved.`,
    data
  })
